import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'
import { AssetContext } from './SingleAsset'

const ConfirmDeleteDialog = ({ open, onClose }) => {
  const { asset } = useContext(AssetContext)
  const { setToast } = useContext(GlobalContext)
  const navigate = useNavigate()
  const [deleting, setDeleting] = useState(false)

  const handleDelete = () => {
    if (deleting) return
    setDeleting(true)
    API.delete('/asset/' + asset._id)
      .then((res) => {
        if (res.status === 200) {
          setToast({ message: `${asset.assetID} deleted` })
          navigate('/asset-manager')
        } else {
          setToast({
            message:
              res.status === 403
                ? 'Only Governance team members can delete assets.'
                : 'Unable to delete asset. Please try again later.',
            severity: 'error',
          })
          setDeleting(false)
        }
      })
      .catch(() => {
        setToast({
          message: 'Unable to delete asset. Please try again later.',
          severity: 'error',
        })
        setDeleting(false)
      })
  }

  return (
    <Dialog open={open} onClose={deleting ? undefined : onClose}>
      <DialogTitle sx={{ fontWeight: 800 }}>Delete {asset.assetID}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The asset record, its notes and its make ready history will be
          permanently removed. Defects and maintenance logs already recorded
          against it are kept. This cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose} disabled={deleting}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? 'Deleting…' : 'Delete asset'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
